export default "__VITE_ASSET__8a7dc7c1__"